import { render, staticRenderFns } from "./ahRichPopInfo.vue?vue&type=template&id=03655332&"
import script from "./ahRichPopInfo.vue?vue&type=script&lang=js&"
export * from "./ahRichPopInfo.vue?vue&type=script&lang=js&"
import style0 from "./ahRichPopInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports